'use strict';

var TPromise = window.Promise || require('promise');


var map, pin, pinSelected, previousMarker = null;
var autocompleteInput = $('.core-storelocator-formArea-contentInput input')[0];

var opts, gmapsOpts;
var opts = $('.core-storelocator').data('options');
var baiduStyles = $('.core-storelocator').data('baidustyle');
$('.core-storelocator').removeAttr('data-baidustyle data-options');

var BaiduMapsLoader = {
    WINDOW_CALLBACK_NAME: '__baidu_maps_api_provider_initializator__',
    KEY: opts.baiduKey
};

var markers = [];
var geoloc;
var hasUChangedMapEvent = false;
var isSearch = window.location.search.length > 2; //TODO find more reliable way for this
var markersMap = {};
var layers = {'all': []};
var clusterer;
var activeLayer;
var markerClusterer, markerSelect;
var compteur = 0;

var mapsLoaded = new TPromise(function (res, rej) {
    var script = document.createElement('script');
    script.src = 'https://api.map.baidu.com/api?v=2.0&ak=' +
        BaiduMapsLoader.KEY +
        '&callback=' +
        BaiduMapsLoader.WINDOW_CALLBACK_NAME;

    document.body.appendChild(script);
    window[BaiduMapsLoader.WINDOW_CALLBACK_NAME] = function() {
      var script1 = document.createElement('script');
      script1.src = "https://api.map.baidu.com/library/TextIconOverlay/1.2/src/TextIconOverlay_min.js";
      document.body.appendChild(script1);

      var script2 = document.createElement('script');
      script2.src = "https://api.map.baidu.com/library/MarkerClusterer/1.2/src/MarkerClusterer_min.js";

      if (script1.readyState){  //IE
          script1.onreadystatechange = function(){
              if (script1.readyState == "loaded" ||
                      script1.readyState == "complete"){
                  script1.onreadystatechange = null;
                  document.body.appendChild(script2);
              }
          };
      } else {  //Others
          script1.onload = function(){
              document.body.appendChild(script2);
          };
      }

      if (script2.readyState){  //IE
          script2.onreadystatechange = function(){
              if (script2.readyState == "loaded" ||
                      script2.readyState == "complete"){
                  script2.onreadystatechange = null;
                  res();
              }
          };
      } else {  //Others
          script2.onload = function(){
              res();
          };
      }
    }
});

var zoomLevelSwitch = 13;

require('jquery-keyboard-focus');
var util = require('../lib/util');
function setCoordsToFloat(gmapsOpts) {

    //just making sure that if lat and long have values, they're set as float.
    gmapsOpts.center.lat = (gmapsOpts.center.lat) ? parseFloat(gmapsOpts.center.lat) : gmapsOpts.center.lat;
    gmapsOpts.center.lng = (gmapsOpts.center.lng) ? parseFloat(gmapsOpts.center.lng) : gmapsOpts.center.lng;

	return gmapsOpts
}
exports.init = function () {
  util.keyBoardFocus();
  opts = $('.core-storelocator').data('options');
  gmapsOpts = opts.gmapsOptions;
  gmapsOpts = setCoordsToFloat(gmapsOpts);

  if (opts.isGeolocated) {
      geoloc = opts.geolocation;
  }

  var geolocated = geolocate().catch(function (e) {console.log('location disabled');});

  var mapsInit = mapsLoaded.then(function (_baiduMap) {
     return new TPromise(function(res, rej) {
          initMapBaidu();
          res();
          initBMapAutocomplete();
      });
  }, rej);

  var tilesLoaded = mapsInit.then(function () {
      return new TPromise(function (res, rej) {
          addOnceListenerBaidu('tilesloaded', res);
      });
  }, rej);

  var clusterInit;
  if (isSearch && !opts.isGeolocated) {
      clusterInit = mapsInit
          .then(initClusterBaidu)
          .catch(rej);
  } else {
      clusterInit = mapsInit
          .then(initCountryBaidu)
          .then(initClusterBaidu)
          .catch(rej);

      TPromise.all([geolocated, clusterInit])
          .then(initGeolocationBaidu)
          .then(markGeolocationBaidu)
          .catch(rej);
  }

  TPromise.all([tilesLoaded, clusterInit])
      .then(function () {
          refreshMarkersBaidu();
          updateResultNbBaidu();
          initUChangedMapEventBaidu();
          $('.core-storelocator-Map').removeClass('pre-init');
      }, rej);

      $('.core-storelocator-items').addClass('core-hide-btnSeeMore');

      $('.core-storelocator-contentList')
          .on('click', '.core-storelocator-item', function (e) {
              var $target = $(e.currentTarget),
                  storeId = $target.data('storeId');

              selectMarkerBaidu(storeId, true);
          })
          .on('click auxclick contextmenu', '.core-storelocator-btnGetDirections', function (e) {
              if (!geoloc) { return; }
              e.stopPropagation();

              var dirStr = '/dir/' + geoloc.latitude + ',' + geoloc.longitude + '/';
              e.target.href = e.target.href.replace('/dir//', dirStr);
          })
        //  .on('click', '.core-storelocator-btnSeemore', seeMore)
          .on('click', '.core-storelocator-btnGoto', function(e) {
              var $item = $(e.target).parents('.core-storelocator-area'),
                  coords = $item.data('bounds').split(','),
                  bounds = { east: 0, north: 0, south: 0, west: 0};

              $.each(bounds, function (key) { bounds[key] = parseFloat(coords.shift()) });
              let pt1 = new BMap.Point(bounds.west, bounds.south);
              let pt2 = new BMap.Point(bounds.east, bounds.north);
              let pts = [pt1, pt2];

              map.setViewport(pts);
              setZoom(gmapsOpts.zoom);
          });

      $('.core-storelocator')
          .on('click', '.js-core-storelocator-geoloc', onGeolocClickBaidu)
          .on('click', '.core-storelocator-btnSearch', applyFilterBaidu);

      $('.js-Storelocator-input').on('focusout', function() {
          $('.js-Storelocator-input').attr('aria-expanded', false);
      });

      $('.js-Storelocator-input').on('focusin click keydown', function() {
          window.setTimeout(function() {
              $('.js-Storelocator-input')
                  .attr('aria-expanded', $('.pac-container').is(':visible'));
          }, 500);
      });
}

function toHttps() {
    window.location.protocol = 'https:';
}

function onGeolocClickBaidu (evt) {
    evt.stopPropagation();
    evt.preventDefault();

    autocompleteInput.value = '';

    geolocate()
        .then(initGeolocationBaidu, toHttps)
        .then(markGeolocationBaidu)
        .then(refreshListBaidu)
        .catch(rej);
}

function refreshSidebar() {
    $('.core-storelocator-items').toggle(map.getZoom() >= gmapsOpts.zoom);
    $('.core-storelocator-areas').toggle(map.getZoom() < gmapsOpts.zoom);

}

function refreshListBaidu() {
    var bounds = map.getBounds(),
        axisClass = opts.filter === 'all' ? '*' : ('.' + opts.filter),
        count = 1;

    $('.core-storelocator-item').hide()
        .filter(axisClass).each(function (i, e) {
            var $e = $(e),
                marker = markersMap[$(e).data('storeId')];

            if (marker === undefined || bounds.containsPoint(marker.point)!==true) { return; }

            $e.show();
            if (opts.isGeolocated && marker.label) {
                $e.find('.core-storelocator-itemNumber').text(count);
                marker.label.text = count++;
            }
            if (geoloc && !isSearch) {
                $e.find('.core-storelocator-itemDistance')
                    .text(computeDistanceBaidu(marker.point));
            }

        });
        util.keyBoardFocus();
}

function applyFilterBaidu(evt) {
    evt.preventDefault();
    var $target = $(evt.currentTarget),
        axis = $target.data('axis');

    opts.filter = axis;

    $('.core-storelocator-btnSearch')
        .removeClass('active')
        .attr('aria-current', false);

    $target
        .attr('aria-current', true)
        .addClass('active');

    activateLayerBaidu(layers[axis]);

    var loadedAjaxMap = loadAjaxMapBaidu({isGeolocated: opts.isGeolocated}, true);

    if (!opts.isGeolocated) {
        loadedAjaxMap.then(refreshMarkersBaidu);
    }

    updateTitle($target);
}

function initGeolocationBaidu() {
    return loadAjaxMapBaidu({
        isGeolocated: 1,
        lat: geoloc.latitude,
        lng: geoloc.longitude
    });

    util.keyBoardFocus();
}

function markGeolocationBaidu() {
    if (!geoloc) { return console.warn('Unknown geolocation'); }

    let pt = new BMap.Point(geoloc.longitude, geoloc.latitude);
    map.setCenter(pt);
    setZoom(gmapsOpts.zoom);

    let icon = new BMap.Icon(opts.location, new BMap.Size(23, 23));
    let m = new BMap.Marker((pt), {
        icon: icon
    });
    m.setZIndex(500);
    map.addOverlay(m);

    util.keyBoardFocus();
    refreshSidebar();
}

function rej() {
    console.error(arguments);
}

function initClusterBaidu() {
    return new TPromise( function(res, rej) {
        if (!window.storelocator_data) {
            window.storelocator_data = [];
            window.storelocator_data.push = function (data) {
                Array.prototype.push.call(window.storelocator_data, data);
                initClusterBaidu().then(res, rej);
            }
            return;
        }

        var data = window.storelocator_data[0];

        for (var j = 0; j < opts.layers.length; j++) {
            layers[opts.layers[j]] = [];
        }

        var icon = new BMap.Icon(opts.pin, new BMap.Size(60, 72));

        for(var d, m, i = 0, l = data.length; i < l; i++) {
            d = data[i];

            let pt = new BMap.Point(d[2], d[1]);
            m = new BMap.Marker((pt), {
                icon: icon
            });
            m.hide();
            m.addEventListener('click', function() {
                selectMarkerBaidu(this.__id);
            }, {passive: true});

            m.__layerNames = d[3];
            m.__id = d[0];
            m.setIcon(pin);

            markersMap[d[0]] = m;
            for (var j = 0; j < opts.layers.length; j++) {
                var layerName = opts.layers[j];
                if (d[3].indexOf(layerName) !== -1) {
                    layers[layerName].push(m);
                }
            }

            layers['all'].push(m);
        }

        var myStyles = [{
            url: opts.clusterMarker,
            size: new BMap.Size(30, 30),
            opt_anchor: [16, 0],
            textColor: 'black',
            opt_textSize: 10
        }];
        markerClusterer = new BMapLib.MarkerClusterer(map, {markers:[]});
        markerClusterer.setStyles(myStyles);
        markerClusterer.setMinClusterSize(1);
      	markerClusterer.setMaxZoom(13);

        activateLayerBaidu(layers['all']);

        res();
    });
    util.keyBoardFocus();
}

function activateLayerBaidu(layer) {
    activeLayer = layer;
    markerClusterer.clearMarkers();
    markerClusterer.addMarkers(layer);

    updateResultNbBaidu();
}

function geolocate() {
    return new TPromise(function(res, rej) {
        if (!navigator.geolocation) { return rej(); }
        if (geoloc) { return res(); }

        navigator.geolocation.getCurrentPosition(function (result) {
            if (isNaN(result.coords.latitude) || isNaN(result.coords.longitude)) { // IE 11
              return rej();
            }
            geoloc = result.coords;

            $('.js-core-storelocator-noGeoloc').slideUp();

            res();
        }, function () {
            $('.js-core-storelocator-noGeoloc').slideDown();
            return rej();
        });
    });
    util.keyBoardFocus();
}

function loadAjaxMapBaidu(options) {
    var baseOpts = {
        ajax: 1,
        filter: opts.filter
    }

    var urlOpts = {
        lat: opts.isGeolocated && geoloc.latitude ||
            map && map.getBounds().getCenter().lat,
        lng: opts.isGeolocated && geoloc.longitude ||
            map && map.getBounds().getCenter().lng
    }

    var ajaxLoaded = $.get(window.location.pathname, $.extend(baseOpts, urlOpts, options)).promise();

    return ajaxLoaded.then(function (resp) {
        if (!map) { return; }
        var areaCurState = $('.core-storelocator-areas').is(':visible');

        opts = $('.core-storelocator').data('options');
        gmapsOpts = opts.gmapsOptions;


        $('.core-storelocator-items')
            .replaceAll('.core-storelocator-items');
        refreshSidebar();
        refreshListBaidu();
    }, rej);
    util.keyBoardFocus();
}

function initCountryBaidu() {
  let point = new BMap.Point(101.841797,35.433724);
  map.centerAndZoom(point,5);
}

function addOnceListenerBaidu(eventName, callback) {
    function listener(e){
        map.removeEventListener(eventName, listener);
        callback();
    }
    map.addEventListener(eventName, listener, {passive: true});
}

var currentZoom;
function setZoom(zoom) {
    currentZoom = zoom;
    map.setZoom(zoom);
}

function initUChangedMapEventBaidu() {
    if (hasUChangedMapEvent) { return; }

    hasUChangedMapEvent = true;

    map.addEventListener('dragend', onUChangedMapBaidu.bind(null, 1000), {passive: true});
    map.addEventListener('moveend', updateResultNbBaidu, {passive: true});

    currentZoom = map.getZoom();
    map.addEventListener('zoomend', onZoomChangeBaidu, {passive: true});
    util.keyBoardFocus();
}

function onZoomChangeBaidu() {
    updateResultNbBaidu();
    refreshSidebar();

    // Workaround false zoom_changed evts triggered from fitBounds
    if (currentZoom !== map.getZoom()) {
        if (currentZoom !== -1) {
            onUChangedMapBaidu();
        }

        currentZoom = map.getZoom();
    }
}

function updateResultNbBaidu() {
    var bounds = map.getBounds(),
        counter = 0,
        counts = {},
        layer = layers['all'];

    if (!bounds) { return; }
    if (!layer.length) { return; }

    for (var key in layers) {
        counts[key] = 0;
    }

    for (var i = 0; i < layer.length; i++) {
        var m = layer[i];

        if (bounds.containsPoint(m.point)===true) {
            for (var key in layers) {
                if (m.__layerNames.indexOf(key) !== -1) {
                    counts[key]++;
                }
            }
            counts['all']++;
        }
    }

    $('#core-storelocator-nbResult').text(counts[opts.filter]);

    $('.core-storelocator-btnSearch').each(function (i, e) {
        var $e = $(e),
            count = counts[$e.data('axis')];
        $e
            .toggleClass('disabled', !count)
            .find('.core-storelocator-textFilter')
                .text(function (i, text) {
                    return text.replace(/\d+/, count);
                });
                util.keyBoardFocus();
    });
}

var boundsTimeout;
function onUChangedMapBaidu(timeout) {
    window.clearTimeout(boundsTimeout);

    boundsTimeout = window.setTimeout(function () {
        loadAjaxMapBaidu().then(refreshMarkersBaidu, rej);
    }, timeout || 500);
}

function initMapBaidu() {
    let _baiduMap = new BMap.Map("containerBaidu", {enableMapClick: false});
    let point = new BMap.Point(101.841797,35.433724);
    _baiduMap.centerAndZoom(point,5);
    _baiduMap.enableDragging();
    _baiduMap.enableScrollWheelZoom();
    _baiduMap.enableDoubleClickZoom();
    _baiduMap.enableKeyboard();

    try {
      if (baiduStyles.hasOwnProperty("mapStyle")) {
        _baiduMap.setMapStyle(baiduStyles.mapStyle);
      } else {
        _baiduMap.setMapStyle({style:"grayscale"});
      }
    } catch (e) {
      _baiduMap.setMapStyle({style:"grayscale"});
    }

    let ctrl_nav = new BMap.NavigationControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT, type: BMAP_NAVIGATION_CONTROL_ZOOM });
    _baiduMap.addControl(ctrl_nav);
    map = _baiduMap;
    //TODO remove me, debug only
    window.map = map;

    pin = {
        url: opts.pin,
        anchor: new BMap.Size(60,72)
    };
    pinSelected = $.extend({}, pin, {url: opts.pinSelected});
    util.keyBoardFocus();
}

function cleanMarkers() {
    for (var i = 0; i < markers.length; i++) {
        markers[i].setMap(null);
    }

    markers = [];
    util.keyBoardFocus();
}

var numberedMarkers = [];
function refreshMarkersBaidu() {
    if (markerSelect) {
      map.removeOverlay(markerSelect);
    }

    var $items = $('.core-storelocator-item'),
        bounds = map.getBounds();

    $items.each(function (i, e) {
        var $e = $(e),
            marker = markersMap[$e.data('store-id')];
          if (marker === undefined) { return;}
        var onMap = bounds.containsPoint(marker.point);


        /*if (i == $items.length) {
            marker.setIcon(pinSelected);
        }
        marker.setIcon(pin);*/

        marker.show();
        marker.setIcon(pinSelected);
        numberedMarkers.push(marker);

        if (onMap) {
          var label = new BMap.Label( '' + (i + 1) );
          label.setOffset(new BMap.Size(23, 25));
          label.setStyle({
            border : "none"
          });
          marker.setLabel(label);
        } else {
            $e.hide();
        }
    });

    updateTitle(false);
    util.keyBoardFocus();
}

var myValue;
function initBMapAutocomplete() {
    var autocomp = new BMap.Autocomplete({input: autocompleteInput});

    autocomp.addEventListener('onconfirm', function(e) {
        var _value = e.item.value,
            geo = new BMap.Geocoder(),
            fullAddress = $.map(_value, function(val, key) { return val; })
                .reverse().join(' ')

        geo.getPoint(fullAddress, onPlaceChangeBaidu, _value.city);

        myValue = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
        setPlace();

    });
}

function onPlaceChangeBaidu(point) {
    var isGMaps = !point,
        name = encodeURIComponent(isGMaps ? this.getPlace().formatted_address : autocompleteInput.value),
        lat = isGMaps ? this.getPlace().geometry.location.lat() : point.lat,
        lng = isGMaps ? this.getPlace().geometry.location.lng() : point.lng;

    isSearch = true;

    $('html, body').animate({ scrollTop: $('.core-storelocator').offset().top}, 1000);

    addOnceListenerBaidu('idle', setZoom.bind(null, 12));
    map.setCenter({ lat: lat, lng: lng });

    return loadAjaxMapBaidu({
            // bounds: map.getBounds().getUrlValue(),
            name: name,
            lat: lat,
            lng: lng
        }).then(refreshMarkersBaidu)
        .then(updateResultNbBaidu);
}

function selectMarkerBaidu(storeId, listOrigin) {
    var marker = markersMap[storeId],
        $items = $('.core-storelocator-items'),
        $allItems = $('.core-storelocator-item'),
        $item = $allItems.filter('[data-store-id=' + storeId + ']');

    $allItems.removeClass('core-storelocator-item--active');
    $item.addClass('core-storelocator-item--active');


    if (window.matchMedia('(min-width: 801px)').matches) { // Desktop
        $items.animate({
            scrollTop: $items.prop('scrollTop') + $item.position().top
        }, 1000);
    } else { // Mobile
        if (listOrigin) {
            $('html, body').animate({ scrollTop: $('.core-storelocator').offset().top}, 1000);
        } else {
            $('html, body').animate({
                scrollTop: $item.offset().top - $(window).height() + $item.height()
            }, 1000);
        }
    }

    map.setCenter(marker.point);
    if (currentZoom > 15) {
      setZoom(currentZoom);
    } else {
      setZoom(15);
    }

    refreshListBaidu();
    refreshMarkersBaidu();

    let labelTxt = marker.getLabel();

    let icon = new BMap.Icon(opts.pinSelected, new BMap.Size(60,72));
    let lb = new BMap.Label(labelTxt.content);
    lb.setOffset(new BMap.Size(23, 25));
    lb.setStyle({
      border : "none",
      'background-color' : "black",
      color : "white"
    });

    markerSelect = new BMap.Marker((marker.point), {
        icon: icon
    });

    markerSelect.setLabel(lb);
    markerSelect.setZIndex(10001);
    compteur = 2;
    map.addOverlay(markerSelect);


    if (previousMarker) {
        previousMarker.label || previousMarker.setLabel('');
        if (typeof previousMarker.label !== 'undefined') {
            previousMarker.label.color = 'black';
        }
        previousMarker.setIcon(pin);
        previousMarker.setZIndex(1);
    }

    marker.label || marker.setLabel('');
    if (typeof marker.label !== 'undefined') {
        marker.label.color = 'white';
    }

    previousMarker = marker;
}

function updateTitle(axis) {
	var title = opts.resourceText.STORE_SEARCH_RESULTS;

	if (autocompleteInput.value.length > 0) {
		title += " " + autocompleteInput.value;
	}

	if (axis !== false && axis.data('axis') != 'all') {
	    var labelAxis = axis.children('span').html().split('(')[0];
		title += " (" + opts.resourceText.STORE_SEARCH_FILTERED + " " + labelAxis + ") ";
	}

	title += opts.resourceText.GLOBAL_STORENAME;

	document.title = title;
}

function computeDistanceBaidu(point) {
  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(point.lat- geoloc.latitude);  // deg2rad below
  var dlng = deg2rad(point.lng- geoloc.longitude);
  var a =
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(deg2rad(geoloc.latitude)) * Math.cos(deg2rad(point.lat)) *
      Math.sin(dlng/2) * Math.sin(dlng/2)
  ;
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  var d = R * c; // Distance in km
  return d > 1 ? (d.toFixed(2) + 'km') : (d.toFixed(3) * 1000 + 'm');
}

function deg2rad(deg) {
  return deg * (Math.PI/180)
}

function setPlace(){

  function myFun(){
  	var pp = local.getResults().getPoi(0).point;
  	map.centerAndZoom(pp, 12);
  }
  var local = new BMap.LocalSearch(map, {
    onSearchComplete: myFun
  });

  local.search(myValue);
}
